// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 23-02-17 Komarov
import moment from 'moment';
import { useWindowWidthAndHeight } from '../../../Helpers/WindowResizeHook';
// ##### 25-02-12 Komarov
import {
  // ##### 2025-09-11 Komarov
  getHotelContent,
  getHotelsAvail,
  // ##### Komarov 2025-10-14
  getPickedCurrencyResponse,
} from '../../../../../Redux/actions';

// ##### 25-05-21 Komarov
import Search from '../../../FirstPageofSearchModule/SearchResizersAndSwitchers/Search';
// ##### 23-03-29 Komarov
import LoadingMessage from '../../../../Library/PageDevices/LoadingMessage';
// ##### 23-09-14 Komarov
// import './HotelItemsCSS.css'
// ##### 23-11-02 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 27-01-25 Komarov
import HotelItemsList from './HotelItemsList';
// ##### 25-02-05 Komarov
import PropertiesFoundHeader from './PropertiesFoundHeader';
// ##### 25-05-10 Komarov
import SearchResultsHeader from './SearchResultsHeader';
// ##### 25-04-30 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const HotelItems = () => {
  // ##### Komarov 2025-07-12
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    localStorage.getItem('clientData') && localStorage.removeItem('clientData');
  }, []);

  // console.log('HOTEL_TITLE', title)

  // ##### 23-03-29 Komarov
  const [width /* height */] = useWindowWidthAndHeight();
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();
  // console.log('HOTEL ITEM LOCATION', location)

  const dispatch = useDispatch();

  // ##### 24-08-05 Komarov
  // TODO: Исправить код в соответствии с задачей убрать Промокод из URL
  // const { selected_currency /* , refpartner */ } = search_data;
  // ##### Komarov 2025-07-21
  const selected_currency = search_data?.selected_currency;
  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(getPickedCurrencyResponse(selected_currency));
  }, [dispatch, selected_currency /* , refpartner */]);

  // ##### 23-02-17 Komarov
  const [smartResultFound, setSmartResultFound] = useState('');

  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  // console.log('[GENERAL_HOTELS] , ' , generalHotelItems)///получаю из смарта имя отеля, айди отеля, сити имя, сити айди

  ///используется непосредственно для вывода названий отелей на странице.
  ///если айди города, который мне приходит первоначально от Саши Ефица (классификатор contracts) не находится в данных, пришедших в результате поиска клиентом,
  ///то в переменную filtered возвращается тур айди из классификатора contracts, равное айди, пришедшему от клиентского поиска
  ///иначе возвращается сити айди из классификатора contracts, равное айди из поиска

  // console.log('[DATE DIFFERENCE]',date_difference)
  // ##### Komarov 2025-09-11
  const sale = useSelector(state => state.company.sale_id);

  const { user: currentUser } = useSelector(state => state.auth);
  // ##### 24-03-01 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);

  // ##### 24-05-23 Komarov
  const deviceType = useSelector(state => state.deviceType);

  // ##### 24-08-05 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);
  const promocode = useSelector(state => state.promocode.promocode);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(
      getHotelContent({
        // ##### 25-04-21 Komarov
        id: 0, // hotel's id
        city_id: search_data?.city_id,
        language: locale,
        user_id: currentUser.user_id,
        refpartner: company_id,
        sale,
        promocode,
        deviceType,
        company_cipher,
        content_size: 0,
      })
    );
  }, [
    currentUser.user_id,
    search_data?.refpartner,
    search_data?.city_id,
    // ##### 25-04-21 Komarov
    search_data?.id, // hotel's id
    sale,
    company_cipher,
    // ##### Komarov 2025-10-14
    locale,
  ]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(
      getHotelsAvail({
        // ##### Komarov 2025-05-26
        sale_id: sale || null,
        promocode,
        deviceType,
        company_cipher: company_cipher || '',
        start: search_data?.start, // date of arrival
        end: search_data?.end, // date of departure
        city_id: search_data?.city_id,
        // ##### 25-04-21 Komarov
        id: search_data?.id, // hotel's id
        adults: search_data?.adults,
        children: search_data?.children,
        // ##### 25-03-11 Komarov
        // lower_cost_limit: 0.0, // lower cost limit of room in USD, NOT OBLIGATORY
        // upper_cost_limit: 200.0, // upper cost limit of room in USD, NOT OBLIGATORY
        quantity: search_data?.rooms, // Quantity of rooms, 1 by default, NOT OBLIGATORY
        user_id: currentUser.user_id,
        refpartner: company_id,
        language: locale,
      })
    );
  }, [
    currentUser.user_id,
    search_data?.refpartner,
    search_data?.start,
    search_data?.end,
    search_data?.city_id,
    // ##### 25-04-21 Komarov
    search_data?.id, // hotel's id
    search_data?.rooms,
    search_data?.adults,
    search_data?.children,
    sale,
    company_cipher,
    // ##### Komarov 2025-10-14
    locale,
  ]);

  const hotelcontent_loaded = useSelector(
    state => state.hotelcontent.hotelcontent_loaded
  );
  const hotels_avail_loaded = useSelector(
    state => state.hotels.hotels_avail_loaded
  );

  // ##### 25-02-03 Komarov
  const showLoader = !hotelcontent_loaded || !hotels_avail_loaded;

  return (
    <>
      <div data-component="HotelItems">
        <Search />
      </div>
      <div className="searchrendering_Wrapper">
        <SearchResultsHeader />

        <div
          // @@@@@ 23-01-30 Komarov: Подвинул выше блок с сообщением о загрузке, чтобы он не накладывался на Footer
          // ##### 27-01-25 Komarov
          style={showLoader ? { height: '250px' } : null}
        >
          {/* ##### 24-06-06 Komarov */}
          {showLoader ? (
            <div>
              {/* ##### 23-02-17 Komarov */}
              <LoadingMessage
                loadingMessageClass="RateLoading"
                smartResultFound={smartResultFound}
              />
            </div>
          ) : (
            <>
              <PropertiesFoundHeader />

              {/* ##### 27-01-25 Komarov */}
              <Media greaterThanOrEqual="Laptop-1024-1440">
                <HotelItemsList
                  ulCLassName="HotelDescriptionUl"
                  width={width * 0.65}
                  liClassName="HotelDescriptionLi"
                />
              </Media>
              {/* ##### 23-04-20 Komarov */}
              <Media lessThan="Laptop-1024-1440">
                <HotelItemsList
                  ulCLassName="HotelDescriptionUlSmallScreen"
                  width={width * 0.9}
                  liClassName="HotelDescriptionLiSmallScreen"
                />
              </Media>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default HotelItems;
